var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMailSmall = function SvgMailSmall(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33368 7.99991C1.33368 5.79705 3.13048 4.00024 5.33335 4.00024H26.6667C28.8695 4.00024 30.6663 5.79705 30.6663 7.99991V23.9999C30.6663 26.2028 28.8695 27.9996 26.6667 27.9996H5.33335C3.13048 27.9996 1.33368 26.2028 1.33368 23.9999V7.99991ZM4.14169 7.40528L16 15.7061L27.8583 7.40528C27.6378 6.969 27.1842 6.66624 26.6667 6.66624H5.33335C4.81583 6.66624 4.3622 6.969 4.14169 7.40528ZM28.0003 10.5601L16.7644 18.4253C16.3055 18.7466 15.6946 18.7466 15.2356 18.4253L3.99968 10.5601V23.9999C3.99968 24.7304 4.60287 25.3336 5.33335 25.3336H26.6667C27.3972 25.3336 28.0003 24.7304 28.0003 23.9999V10.5601Z",
    fill: "#2A60EA"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMailSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "mailSmall.96b08d966d01eb6c45ff89df36e8d810.svg";